/**
 * Floating badge shown over a viewport when a segmentation tool is active.
 * Shows tool-specific label: Segmentation (lasso), Bump Refine, Region Grow.
 */

const BADGE_LABELS: Record<string, string> = {
  lasso: "Segmentation",
  bump: "Bump Refine",
  regionGrow: "Region Grow",
};

export function SegmentationBadge({ activeTool }: { activeTool: string }) {
  const label = BADGE_LABELS[activeTool];
  if (!label) return null;
  return (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 pointer-events-none z-10">
      <div className="px-2.5 py-1 rounded-full text-[10px] font-semibold tracking-wide shadow-lg bg-signal/80 text-white">
        {label}
      </div>
    </div>
  );
}
